<template>
  <div>
    <h1 class="mb-6 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('bank.index')">
        Bank
      </inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama" />
          <text-area-input
            v-model="form.descriptions"
            :error="form.errors.descriptions"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Deskripsi" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button
            :loading="form.processing"
            class="btn-indigo"
            type="submit">
            Create Bank
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextAreaInput from '@/Shared/TextAreaInput'
import { useForm, Link } from '@inertiajs/vue2'

export default {
    metaInfo: { title: 'Create Bank' },
    components: {
        LoadingButton,
        TextInput,
        TextAreaInput,
        'inertia-link': Link,
    },
    layout: Layout,
    remember: 'form',
    data () {
        return {
            form: useForm({
                name: null,
                descriptions: null,
            }),
        }
    },
    methods: {
        store () {
            this.form.post(this.route('bank.store'))
        },
    },
}
</script>
